import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress'

import { PHOTO_ITEM_SIZE } from './InvoicePhotos'
import CommonRepository from 'billing/infra/CommonRepository'

class PhotoItem extends React.Component {

  static propTypes = {
    photo: PropTypes.object.isRequired,
    selectable: PropTypes.bool.isRequired,
    style: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    // Sample image to show, can be one of [small, medium, large(source)]
    sample: PropTypes.string,
    onPhotoItemSelectionChanged: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: false,
      imageUrl: null
    }
  }

  componentDidMount() {
    this.getImageURL(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.photo !== nextProps.photo) {
      this.setState({
        selected: false,
        imageUrl: null
      })
      this.getImageURL(nextProps)
    }
  }

  getImageUniqueId = dpPath => {
    const pathSplit = dpPath.split('/')
    return { eventId: pathSplit[1], photoId: pathSplit[6] }
  }

  getImageURL = props => {
    const { eventId, photoId } = this.getImageUniqueId(props.photo.dbPath)
    // For legacy purposes, we request the sampled image, and if it fails,
    // then return the source.
    if (props.sample && props.sample !== 'source') {
      const sampledPhotoStoragePath = `events/${eventId}/extendedInfo/modules/photos/list/${photoId}/${props.sample}_image.jpg`
      CommonRepository.getImageURL(sampledPhotoStoragePath)
        .then(imageUrl => { this.setState({ imageUrl, sample: props.sample }) })
        .catch(() => {
          // If the sampled image failed, download the source image.
          const largePhotoStoragePath = `events/${eventId}/extendedInfo/modules/photos/list/${photoId}/image.jpg`
          CommonRepository.getImageURL(largePhotoStoragePath)
            .then(imageUrl => { this.setState({ imageUrl, sample: 'source' }) })
        })
    }
    else {
      const largePhotoStoragePath = `events/${eventId}/extendedInfo/modules/photos/list/${photoId}/image.jpg`
      CommonRepository.getImageURL(largePhotoStoragePath)
        .then(imageUrl => { this.setState({ imageUrl, sample: 'source' }) })
    }
  }

  handleImageClicked = () => {
    if (this.props.selectable) {
      const selectionStatus = this.state.selected
      this.setState({
        selected: !selectionStatus
      })
      this.props.onPhotoItemSelectionChanged(!selectionStatus, this.state.sample)
    }
    else {
      this.showFullScreen()
    }
  }

  showFullScreen = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'PHOTO_FULL_SCREEN',
      value: {
        imageUrl: this.state.imageUrl,
        disableDeletion: true
      }
    })
  }

  render() {
    if (!this.state.imageUrl) {
      return <div style={styles.progress(PHOTO_ITEM_SIZE, PHOTO_ITEM_SIZE)}>
        <CircularProgress size={PHOTO_ITEM_SIZE/2} thickness={2} />
      </div>
    }
    return (
      <div style={{ ...styles.content, ...this.props.style}}>
        <img
          style={styles.image}
          onClick={this.handleImageClicked}
          src={this.state.imageUrl}
          width={PHOTO_ITEM_SIZE}
          height={PHOTO_ITEM_SIZE} />
        { this.state.selected &&
          <i className='material-icons' style={styles.selected}>done</i>
        }
      </div>
    )
  }

}

const styles = {
  selected: {
    position: 'absolute',
    color: '#356992',
    fontSize: 14,
    fontWeight: 500
  },
  content: {
    cursor: 'pointer'
  },
  image: {
    borderRadius: 4
  },
  progress: (width, height) => ({
    width,
    height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })
}

export default connect()(PhotoItem)



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/photos/PhotoItem.js